import React, { useEffect } from 'react';
import { TelegramVisualButton } from '@/components/telegram-visual-button';
import { hideMainButton, isTelegramWebApp } from '@/lib/telegram-service';

interface TelegramHybridButtonProps {
  text: string;
  onClick: () => void;
  color?: string;
  textColor?: string;
  visible?: boolean;
  disabled?: boolean;
  showProgress?: boolean;
  className?: string;
  hideOnKeyboard?: boolean; // Se false, il pulsante rimane visibile anche con tastiera aperta
}

/**
 * Componente che mostra sempre e solo il pulsante visuale.
 * Non usa più il MainButton di Telegram, così è sempre visibile
 * sia in Telegram che nell'area di sviluppo.
 */
export function TelegramHybridButton(props: TelegramHybridButtonProps) {
  console.log('[TelegramHybridButton] Rendering solo pulsante visuale:', { 
    visible: props.visible,
    text: props.text,
    onClick: typeof props.onClick,
    disabled: props.disabled
  });

  // Wrapper per aggiungere feedback tattile
  const handleClick = () => {
    console.log('[TelegramHybridButton] Click intercepted - aggiungendo feedback tattile...');
    
    // Feedback tattile
    try {
      if (window.Telegram?.WebApp?.HapticFeedback) {
        console.log('[TelegramHybridButton] ✅ Attivando feedback tattile Telegram...');
        window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');
      } else if (navigator.vibrate) {
        console.log('[TelegramHybridButton] ✅ Fallback a vibrazione browser...');
        navigator.vibrate(50);
      }
    } catch (error) {
      console.error('[TelegramHybridButton] ❌ Errore feedback tattile:', error);
    }

    // Esegui il click originale
    props.onClick?.();
  };

  // Nascondi esplicitamente il MainButton di Telegram
  useEffect(() => {
    if (isTelegramWebApp()) {
      console.log('[TelegramHybridButton] Nascondendo MainButton di Telegram...');
      hideMainButton();
    }
  }, []);

  return (
    <div className="telegram-hybrid-wrapper">
      <TelegramVisualButton 
        {...props} 
        onClick={handleClick}
      />
    </div>
  );
}

export default TelegramHybridButton;